import React from 'react';

import ActionButton from 'jbc-front/components/ActionButton';
import Edit from 'jbc-front/components/icons/Edit';
import { useTranslation } from 'react-i18next';

const EditActionBtn = props => {
  const { t } = useTranslation();
  const { onClick, label = t('features.EmployeeBonus.components.ActionButtonSection.edit'), ...rest } = props;
  return (
    <ActionButton as="button" icon={<Edit />} onClick={onClick} {...rest}>
      {label}
    </ActionButton>
  );
};

export default EditActionBtn;
